export const boardBacklogTour = {
  key: "boardBacklog",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-backlog-list"]',
      content: t("Tour_BoardBacklog_List"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-backlog-filter"]',
      content: t("Tour_BoardBacklog_Filter"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-backlog-tasks"]',
      content: t("Tour_BoardBacklog_MoveToSprint"),
      placement: "top",
    },
  ],
};
